import { safeGtag } from '@/lib/analytics'

export type MediaAnalyticsEvent =
  | 'media_video_click'
  | 'media_video_play'
  | 'media_view_all'
  | 'media_instagram_follow'
  | 'media_category_click'
  | 'media_share'

export function trackMediaEvent(
  event: MediaAnalyticsEvent,
  params?: Record<string, string | number | boolean | undefined>,
) {
  const payload = { event_category: 'media_center', ...params }

  if (typeof window !== 'undefined' && typeof window.gtag === 'function') {
    safeGtag('event', event, payload)
  }
}
